/**
 * Art eines Zahlungsexports
 */
export enum PaymentExportType {
   /**
    * Gemischte Rechnungen aller Kategorien.
    */
   mixed = "mixed",

   /**
    * Geburtstagsrechnungen.
    */
   birthdayBookings = "birthdayBookings",

   /**
    * Ferienbetreuungsrechnungen.
    */
   holidayProgramBookings = "holidayProgramBookings",

   /**
    * Gruppenbuchungsrechnungen.
    */
   groupBookings = "groupBookings",

   /**
    * Kursbuchunungsrechnungen.
    */
   workshopBookings = "workshopBookings",

   /**
    * Mitgliedschaftsrechnungen.
    */
   memberships = "memberships",

   /**
    * Verleihbuchungsrechnungen.
    */
   rentalBookings = "rentalBookings",

   /**
    * Veranstaltungsbuchungsrechnungen.
    */
   eventBookings = "eventBookings"
}

export const PaymentExportTypeNames = {
   mixed: "Gemischt",
   birthdayBookings: "Geburtstage",
   holidayProgramBookings: "Ferienbetreuung",
   groupBookings: "Gruppen",
   workshopBookings: "Kurse",
   rentalBookings: "Verleih",
   memberships: "Mitgliedschaft",
   eventBookings: "Veranstaltungen"
};